import { gql } from '@apollo/client';
import { EEntityType } from '@sharedInterfaces/globalEnums';
import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';
import { setCompanyVersion } from '@store/reducer/companyReducer';
import { setETTs } from '@store/reducer/employeeTalkTemplatesReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

interface EmployeeTalkTemplatesResult {
    employeeTalkTemplates: {
        templates: IEmployeeTalkTemplate[] | null;
        version: number;
    };
}

const GET_EMPLOYEE_TALK_TEMPLATES = gql`
  query GetEmployeeTalkTemplates($version: Int!) {
    employeeTalkTemplates(version: $version) {
      templates {
        id
        title
        description
        templateVersion
        pages {
          id
          title
          order
          sections {
            id
            title
            order
            columns {
              id
              components {
                id
                type
                label
                description
                required
                order
                properties
              }
            }
          }
        }
        isActive
        createdAt
        changedAt
      }
      version
    }
  }
`;

export async function getEmployeeTalkTemplates(): Promise<IEmployeeTalkTemplate[] | null> {
    const state = store.getState();
    const versions = state.company.versions;

    return GraphQL.query<EmployeeTalkTemplatesResult>(GET_EMPLOYEE_TALK_TEMPLATES, { version: versions.ett }).then(
        (obj) => {
            if (!obj) throw new Error('Fehler beim laden der Mitarbeitergespräche.');
            const data = obj.employeeTalkTemplates.templates;
            if (data) {
                data.forEach((t) => {
                    switch (typeof t.id) {
                        case 'string':
                            t.id = Number.parseInt(t.id);
                            break;
                    }
                });
                store.dispatch(
                    setCompanyVersion(EEntityType.EMPLOYEE_TALK_TEMPLATE, obj.employeeTalkTemplates.version),
                );
                store.dispatch(setETTs(data));
                return data;
            }
            return state.employeeTalkTemplates;
        },
    );
}
